<template>
  <!--
      作者：kmdshop
      时间：2019-10-25
      描述：应用-公众号设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="250px">
      <!--公众号设置-->
      <div class="common-form">公众号设置</div>

      <el-form-item label="AppID 公众号ID">
        <el-input v-model="form.mpapp_id" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="AppSecret 公众号密钥">
        <el-input
          v-model="form.mpapp_secret"
          type="password"
          class="max-w460"
        ></el-input>
      </el-form-item>
      <el-form-item label="公众号名称">
        <el-input
          v-model="form.mpapp_name"
          class="max-w460"
        ></el-input>
      </el-form-item>
      <el-form-item label="公众号二维码">
        <el-button @click="chooseImg">选择图片</el-button>

        <div v-if="wx_img" class="image-box">
          <img
            class="mt10"
            :src="wx_img"
            @click="gotoImage(wx_img)"
            width="200"
          />
          <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg">
              <i class="el-icon-close"></i>
          </a>
        </div>

      </el-form-item>
<!-- 
      <div class="common-form">
        微信支付设置
      </div>

      <el-form-item label="微信支付商户号 MCHID">
        <el-input v-model="form.mchid" class="max-w460"></el-input>
        <div class="tips">
          微信支付配置输入h5端的域名即可   
        </div>
      </el-form-item>
      <el-form-item label="微信支付密钥 APIKEY ">
        <el-input v-model="form.apikey" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="apiclient_cert.pem">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="使用文本编辑器打开apiclient_cert.pem文件，将文件的全部内容复制进来"
          v-model="form.cert_pem"
          class="max-w460"
        ></el-input>
        <div class="tips">
          使用文本编辑器打开apiclient_key.pem文件，将文件的全部内容复制进来
        </div>
      </el-form-item>
      <el-form-item label="apiclient_key.pem">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="使用文本编辑器打开apiclient_cert.pem文件，将文件的全部内容复制进来"
          v-model="form.key_pem"
          class="max-w460"
        ></el-input>
        <div class="tips">
          使用文本编辑器打开apiclient_key.pem文件，将文件的全部内容复制进来
        </div>
      </el-form-item>


        <div class="common-form">在线帮助</div>
        <el-form-item label="api网址">
            {{api_url}}
        </el-form-item>
  
        <el-form-item label="app_id">

          {{appinfo.app_id}}
        </el-form-item>
        <div  v-if="versionjson.site_url!='#'">
          <el-form-item label="代码下载">
            <a :href='versionjson.site_url+"/system/?app=mp&do=download&name="+versionjson.name+"&version="+versionjson.version' target="_blank">点击查看详情</a>
          </el-form-item>
          <el-form-item label="公众号或H5配置">
            <a :href='versionjson.site_url+"/system/?app=mp&do=help&name="+versionjson.name+"&version="+versionjson.version' target="_blank">点击查看详情</a>
          </el-form-item>
          <el-form-item label="微信支付配置">
            <a :href='versionjson.site_url+"/system/?app=mp&do=weixin_pay&name="+versionjson.name+"&version="+versionjson.version' target="_blank">点击查看详情</a>
          </el-form-item>
        </div> -->


      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </div>
    </el-form>
    <!--上传图片-->
    <Upload
      v-if="isupload"
      :isupload="isupload"
      :config="{ total: 1 }"
      @returnImgs="returnImgsFunc"
    ></Upload>
  </div>
</template>

<script>
import AppSettingApi from "@/api/appsetting.js";
import Upload from "@/components/file/Upload";
export default {
  components: {
    Upload,
  },
  data() {
    return {
      /*切换菜单*/
      // activeIndex: '1',
      /*form表单数据*/
      form: {},
      wx_img:'',
      /*是否打开图片选择*/
      versionjson:{},
      api_url:'',
      /*是否打开图片选择*/
      isupload: false,
      appinfo:{
        app_id:''
      },
    };
  },
  created() {
    this.getData();
    this.api_url =  window.location.protocol + '//' + window.location.host;
  },

  methods: {
    /*获取数据*/
    getData() {
      let self = this;
      AppSettingApi.appmpDetail({}, true)
        .then((data) => {
          if (data.data.data != null) {
            self.form = data.data.data;
            if(data.data.data.image){
              self.form.wx_image = data.data.data.image.file_path;
              self.wx_img = self.form.wx_image;
              self.form.qrcode = data.data.data.image.file_id;
            }
          }
          self.versionjson = data.data.version;
          self.appinfo.app_id = data.data.app.app_id;
        })
        .catch((error) => {});
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      let params = this.form;
      AppSettingApi.editAppMp(params, true)
        .then((data) => {
          self.$message({
            message: "恭喜你，设置成功",
            type: "success",
          });
          self.$router.push("/appsetting/appmp/index");
        })
        .catch((error) => {});
    },
    /*选择图片*/
    chooseImg() {
      this.isupload = true;
    },
    /*关闭选择图片*/
    returnImgsFunc(e) {
      this.isupload = false;
      this.wx_img = e[0].file_path;
      this.form.wx_image = e[0].file_path;
      this.form.qrcode = e[0].file_id;
    },
    /*图片跳转*/
    gotoImage(e) {
      window.open(e);
    },
    deleteImg() {
      this.wx_img = '';
      this.form.wx_image = '';
      this.form.qrcode = ''
    },
  },
};
</script>

<style scoped="scoped">
.tips {
  color: #ccc;
}
.delete-btn {
    position: absolute;
    top: 42px;
    left: 184px;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    float: left;
    /*display: none;*/
  }

  /*.image-box:hover .delete-btn {
    display: block;
  }*/

  .image-box {
    display: contents;
    width: 110px;
    height: 110px;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/views/appsetting/appmp/index.vue